<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      :action="baseURL + url"
      :show-file-list="false"
      :on-success="addEventOnSuccess"
      :on-error="addEventOnError"
      :headers="headers"
      :cancel-loading="cancelLoading"
      :on-progress="addOnProgress"
      :data="params"
      :before-upload="beforeAvatarUpload"
      :multiple="multiple"
      :limit="100"
      :close-parent="closeParent"
      :update-percent="updatePercent"
      :upload-success="uploadSuccess"
      :accept="accept"
    >
      <slot name="content" />
    </el-upload>
  </div>
</template>
<script>
import { baseURL } from '@/api/config';
// let loading ;
export default {
  name: 'NfUpload',
  props: {
    // 上传时附带的额外参数
    params: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Object,
      default: () => {},
    },
    cancelLoading: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: '',
    },
    // 1是合同 2是照片
    type: {
      type: String,
      default: '1',
    },
    // 是否允许上传多个
    multiple: {
      type: Boolean,
      default: true,
    },
    // 上传成功回调
    addEventUpload: {
      type: [Boolean, Function],
      default: false,
    },
    // 文件上传成功的提示文字
    successMsg: {
      type: String,
      default: '',
    },
    beforeUpload: {
      type: [Boolean, Function],
      default: false,
    },
    closeParent: {
      type: [Boolean, Function],
      default: false,
    },
    updatePercent: {
      type: [Boolean, Function],
      default: false,
    },
    uploadSuccess: {
      type: [Boolean, Function],
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseURL,
    };
  },
  methods: {
    // 开始上传
    addOnProgress(event, file) {
      this.$emit('onProgress');
    },
    // 上传成功
    async addEventOnSuccess(data) {
      // 需求需要，关闭弹窗，显示进度
      if (this.cancelLoading) {
        // 调解析接口
        // loading.close();
        if (data.data) {
          this.uploadSuccess(data.data);
        } else {
          this.$$message(data.message, 'error');
        }
        return;
      }
      if (data.code == 1 || data.code == 200) {
        this.$emit('addEventUpload', data);
      } else {
        this.$$message(data.message, 'error');
      }
      // loading.close();
    },
    // 上传失败
    addEventOnError() {
      if (this.cancelLoading) {
        this.closeParent(true);
      }
      this.$$message('上传失败', 'error');
      // loading.close();
    },
    beforeAvatarUpload(file) {
      if (this.cancelLoading) {
        this.closeParent(true);
      }
      if (this.beforeUpload) {
        return this.beforeUpload(file);
      }
      if (this.type === '0') {
        const isJPG = file.name.includes('.xlsx') || file.name.includes('.xls');
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!isJPG) {
          this.$message.error('上传文件只能是 xlsx 或者 xls 格式!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 5MB!');
          return false;
        }
        return isJPG && isLt2M;
      } else if (this.type === '1') {
        const isDoc = file.name.includes('.doc') || file.name.includes('.docx');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isDoc) {
          this.$message.error('只能上传 doc 或者 docx 格式!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!');
          return false;
        }
        return isDoc && isLt2M;
      } else if (this.type === '2') {
        const isJPG =
          file.name.includes('.jpeg') || file.name.includes('.jpg') || file.name.includes('.png');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG 或者 PNG 格式!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 10MB!');
          return false;
        }
        return isJPG && isLt2M;
      } else {
        const isJPG = file.name.includes('.xlsx');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传文件只能是 xlsx 格式!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!');
          return false;
        }
        return isJPG && isLt2M;
      }
    },
  },
};
</script>
